<template>
  <div>
    <div class="content">
      <div class="content-c5">
        <div class="cont-share m-t-20">
          <p class="m-l-10 f-w f-t-15 wihte-color">{{ $lang.common_txt57 }}</p>
          <div v-if="inviteCode" class="d-flex">
            <div class="content-c3--b m-l-10">
              <p>{{ inviteCode }}</p>
              <p class="fz-txt" @click="copyText">
                {{ $lang.common_txt56 }}
              </p>
            </div>
          </div>
          <p class="t-c m-t-10 f-w wihte-color">{{ $lang.common_txt58 }}</p>
          <div
            class="d-flex m-l-10 m-t-10"
            v-drag-scroll
            style="
              overflow-x: auto;
              cursor: grab;
              user-select: none; /* 防止选中文本 */
              white-space: nowrap;
              min-width: 245px;
            "
          >
            <div
              class="m-r-10 t-c"
              v-for="(item, index) in shareList"
              :key="index"
              @click="shareContent(index)"
            >
              <img :src="item.img" width="25" />
              <p style="font-size: 9px" class="t-c m-t-5 wihte-color">
                {{ item.name }}
              </p>
            </div>
          </div>
        </div>
        <!-- <p class="font-color m-t-10">
          {{ $lang.share_txt2 }}
        </p> -->
        <!-- <img
          src="../../assets/img/share/share_list.png"
          width="100%"
          @click="shareContent"
        /> -->
      </div>
      <div
        style="
          background-image: linear-gradient(180deg, #ffffff 0%, #ebf6ff 100%);
          box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
          border-radius: 12px;
          margin-top: 10px;
          padding: 20px 0 10px;
        "
      >
        <p class="t-c f-t-15 f-w" style="color: #0077bb">
          {{ $lang.common_txt34 }}
        </p>
        <img
          class="m-t-10"
          src="../../assets/img/share/share-fx.png"
          width="100%"
          style="border-radius: 12px"
        />
      </div>
      <!-- 
      <div class="d-flex m-t-10">
        <img src="../../assets/img/home/mine-left.png" width="30" />
        <span class="m-l-5 f-t-15 f-w">Direct Commission</span>
      </div> -->

      <div class="content-c3 m-t-10">
        <p class="d-flex content-c3-xx">
          <img
            src="../../assets/img/common/0021_qun_bai.png"
            width="20"
            class="m-r-5"
          />
          <span class="wihte-color">{{ $lang.common_txt141 }}</span>
        </p>
        <div class="content-c3--t">
          <p>{{ $lang.common_txt48 }}</p>
          <p>{{ $lang.common_txt49 }}</p>
          <p>{{ $lang.common_txt50 }}</p>
        </div>
        <div
          class="content-c3--t2"
          v-for="(item, index) in InitDate"
          :key="index"
          :style="
            (index + 1) % 2 === 0
              ? {}
              : { backgroundColor: 'rgba(255, 255, 255, 0.02)' }
          "
        >
          <p>
            {{ item.vipLevel }}
          </p>
          <p>
            {{ item.reward }}
          </p>
          <p class="info2-color">
            {{ item.ratino }}
          </p>
        </div>
      </div>
      <div
        class="d-flex f-t-15 f-w m-t-10 m-b-10"
        style="justify-content: center"
      >
        <span class="share-bot-l"></span>
        <span>{{ $lang.common_txt35 }}</span>
        <span class="share-bot-r"></span>
      </div>

      <div v-html="$lang.common_txt36" class="l-h-20"></div>
    </div>
  </div>
</template>
<script>
import VueQr from 'vue-qr'
import { Init } from '@/api/common'
import { contentOf, isOkResponse } from '@/components/loginFlow'
import { safeGetStorageItem, safeLocalStorage } from '@/utils/safeStorage'
import { openExternalUrl } from '@/views/layout/safeLayout'
import {
  copyTextToClipboard,
  hasShareUnavailableMarker,
  safeInviteCode,
  safeInviteUrl,
  shareFailMessage
} from './shareSafety'

const SHARE_READ_MARKER_KEYS = [
  'dataUnavailable',
  'data_unavailable',
  'readFailure',
  'read_failure',
  'readFailed',
  'read_failed',
  'fallback',
  'fallbackUsed',
  'fallback_used',
  'technicalMarker',
  'technical_marker',
  'backendFailure',
  'backend_failure'
]

function shareMarkerToken(value) {
  return String(value == null ? '' : value).trim().toLowerCase()
}

function isActiveShareFlag(value) {
  const token = shareMarkerToken(value)
  return value === true || value === 1 || ['true', '1', 'yes', 'on'].includes(token)
}

function hasShareSuccessMarker(value) {
  if (!value || typeof value !== 'object') return false
  return [value.status, value.state, value.result, value.code, value.success].some(item => {
    if (item === true || item === 0) return true
    const token = shareMarkerToken(item)
    return ['ok', 'success', 'true', '0'].includes(token)
  })
}

function hasShareNeedLoginMarker(value, depth = 0, seen = new Set()) {
  if (!value || typeof value !== 'object' || depth > 8 || seen.has(value)) return false
  seen.add(value)
  const body = Array.isArray(value) ? value : Object.values(value)
  if (!Array.isArray(value)) {
    if (isActiveShareFlag(value.needLogin) || isActiveShareFlag(value.need_login)) return true
    if ([value.status, value.state, value.code, value.errorCode, value.message, value.msg].some(item => {
      const token = shareMarkerToken(item)
      return ['need_login', 'needlogin', 'login_required', '401', 'unauthorized', 'token_expired', 'expired_token', 'login_expired', 'session_expired'].includes(token)
    })) return true
  }
  return body.some(item => hasShareNeedLoginMarker(item, depth + 1, seen))
}

function hasShareReadUnavailableMarker(value, depth = 0, seen = new Set()) {
  if (!value || typeof value !== 'object' || depth > 8 || seen.has(value)) return false
  seen.add(value)
  const body = Array.isArray(value) ? value : Object.values(value)
  if (!Array.isArray(value)) {
    if (SHARE_READ_MARKER_KEYS.some(key => isActiveShareFlag(value[key]))) return true
    if ([value.status, value.state, value.result, value.code, value.errorCode, value.message, value.msg, value.reason, value.fallbackSource, value.fallback_source].some(item => {
      const token = shareMarkerToken(item)
      return token.includes('data_unavailable') ||
        token.includes('data-unavailable') ||
        token.includes('data unavailable') ||
        token.includes('read_failure') ||
        token.includes('read-failure') ||
        token.includes('read failure') ||
        token.includes('read_failed') ||
        token.includes('read-failed') ||
        token.includes('read failed') ||
        token.includes('technical_marker') ||
        token.includes('technicalmarker') ||
        token.includes('technical marker') ||
        token.includes('technical-marker') ||
        token.includes('backend_failure') ||
        token.includes('backendfailure') ||
        token.includes('backend failure') ||
        token.includes('backend-failure') ||
        token.includes('fallback')
    })) return true
  }
  return body.some(item => hasShareReadUnavailableMarker(item, depth + 1, seen))
}

function hasShareBlockingMarker(value, depth = 0, seen = new Set()) {
  if (!value || typeof value !== 'object' || depth > 8 || seen.has(value)) return false
  seen.add(value)
  const body = Array.isArray(value) ? value : Object.values(value)
  if (!Array.isArray(value)) {
    const flags = [
      value.blocked,
      value.block,
      value.writeBlocked,
      value.write_blocked,
      value.backendBlocked,
      value.backend_blocked,
      value.actionBlocked,
      value.action_blocked,
      value.falseProof,
      value.false_proof,
      value.failClosed,
      value.fail_closed,
      value.unconfirmed,
      value.unconfirmedSuccess,
      value.unconfirmed_success
    ]
    if (flags.some(isActiveShareFlag)) return true
    if ([value.status, value.state, value.result, value.marker, value.type, value.code, value.errorCode].some(item => {
      const token = shareMarkerToken(item)
      return token.includes('write_blocked') ||
        token.includes('writeblocked') ||
        token.includes('write blocked') ||
        token.includes('write-blocked') ||
        token.includes('backend_blocked') ||
        token.includes('backendblocked') ||
        token.includes('backend blocked') ||
        token.includes('backend-blocked') ||
        token.includes('action_blocked') ||
        token.includes('actionblocked') ||
        token.includes('action blocked') ||
        token.includes('action-blocked') ||
        token.includes('falseproof') ||
        token.includes('false_proof') ||
        token.includes('false-proof') ||
        token.includes('false proof') ||
        token.includes('failclosed') ||
        token.includes('fail_closed') ||
        token.includes('fail-closed') ||
        token.includes('fail closed') ||
        token.includes('unconfirmed') ||
        token === 'blocked'
    })) return true
  }
  return body.some(item => hasShareBlockingMarker(item, depth + 1, seen))
}

function getLocalStorage() {
  try {
    if (typeof safeLocalStorage === 'function') return safeLocalStorage()
  } catch (e) {
    return null
  }
  return null
}

function getLocationOrigin() {
  try {
    return typeof window !== 'undefined' && window && window.location ? (window.location.origin || '') : ''
  } catch (e) {
    return ''
  }
}

function getBrowserNavigator() {
  try {
    return typeof navigator !== 'undefined' && navigator ? navigator : null
  } catch (e) {
    return null
  }
}

function canUseNativeShare() {
  try {
    return typeof navigator !== 'undefined' && navigator && typeof navigator.share === 'function'
  } catch (e) {
    return false
  }
}

function isNativeShareCancel(error) {
  const errorName = error && error.name
  return errorName === 'AbortError' || errorName === 'NotAllowedError'
}

const nativeShareHandledErrors = typeof WeakSet !== 'undefined' ? new WeakSet() : null

function markNativeShareFailureHandled(error) {
  try {
    if (nativeShareHandledErrors && error && (typeof error === 'object' || typeof error === 'function')) {
      nativeShareHandledErrors.add(error)
    }
  } catch (e) {
    return false
  }
  return true
}

function wasNativeShareFailureHandled(error) {
  try {
    return !!(nativeShareHandledErrors && error && (typeof error === 'object' || typeof error === 'function') && nativeShareHandledErrors.has(error))
  } catch (e) {
    return false
  }
}

export default {
  name: 'ShareOnes',
  // eslint-disable-next-line vue/no-unused-components
  components: { VueQr },
  data() {
    return {
      inviteCode: '',
      shareList: [
        {
          img: require('@/assets/img/common/fenxiang.png'),
          name: 'Share'
        },
        {
          img: require('@/assets/img/common/img_wa.png'),
          name: 'WhatsApp'
        },
        {
          img: require('@/assets/img/common/img_tg.png'),
          name: 'Telegram'
        },
        {
          img: require('@/assets/img/common/huohua.png'),
          name: 'Instagram'
        },
        {
          img: require('@/assets/img/common/youtub.png'),
          name: 'Youtobe'
        },
        {
          img: require('@/assets/img/common/img_facebook.png'),
          name: 'Facebook'
        },
        {
          img: require('@/assets/img/common/douyin.png'),
          name: 'Tiktok'
        },
        {
          img: require('@/assets/img/common/img_x.png'),
          name: 'X'
        }
      ],
      InitDate: [
        { vipLevel: '1', reward: '1', ratino: '0.50%' },
        { vipLevel: '2', reward: '300.000', ratino: '1.50%' },
        { vipLevel: '3', reward: '900.000', ratino: '2.00%' },
        { vipLevel: '4', reward: '1.500.000', ratino: '4.00%' },
        { vipLevel: '5', reward: '3.000.000', ratino: '5.00%' }
      ]
    }
  },
  mounted() {
    if (this.token) {
      this.Init()
    }
  },
  methods: {
    lang() {
      return this.$lang || {}
    },
    toast(options) {
      if (typeof this.$toast === 'function') this.$toast(options)
    },
    showToast(options) {
      this.toast(options)
    },
    requireLogin() {
      if (this.$bus) this.$bus.$emit('openLogin')
    },
    requiresShareLogin() {
      if (this.token) return false
      this.inviteCode = ''
      this.requireLogin()
      const lang = this.lang()
      this.showFailToast(lang.common_txt114 || 'Please log in first')
      return true
    },
    showFailToast(message) {
      const lang = this.lang()
      this.showToast({
        message: message || lang.common_txt114 || 'Request failed',
        icon: 'cross'
      })
    },
    inviteUnavailableMessage(data) {
      const lang = this.lang()
      return shareFailMessage(
        data,
        lang.common_txt114 || 'Invite link is unavailable'
      )
    },
    ensureInviteLink() {
      if (this.inviteCode) return true
      const lang = this.lang()
      this.showFailToast(lang.common_txt114 || 'Invite link is unavailable')
      return false
    },
    shareUnsupportedMessage(platform) {
      const name = platform || 'social'
      const lang = this.lang()
      return lang.common_txt114 || `${name} sharing is not configured`
    },
    showUnsupportedShareTarget(platform) {
      this.showFailToast(this.shareUnsupportedMessage(platform))
      return false
    },
    showNativeShareFailure(error) {
      if (isNativeShareCancel(error)) return
      this.showFailToast((error && (error.msg || error.message)) || 'Unable to share. Please try again.')
    },
    shareContent(i) {
      if (this.requiresShareLogin()) return
      if (i === 0) {
        if (!this.ensureInviteLink()) return
        if (canUseNativeShare()) {
          const guardedNavigator = getBrowserNavigator()
          const shareResult = (() => {
            try {
              const share = guardedNavigator && guardedNavigator.share
              if (typeof share !== 'function') {
                const lang = this.lang()
                this.showFailToast(lang.common_txt114 || 'Sharing is not supported on this browser')
                return null
              }
              return share.call(guardedNavigator, {
                title: 'VUKAVI',
                text: 'VUKAVI',
                url: this.inviteCode
              })
            } catch (error) {
              this.showNativeShareFailure(error)
              markNativeShareFailureHandled(error)
              return Promise.reject(error)
            }
          })()
          if (shareResult && typeof shareResult.catch === 'function') {
            shareResult.catch((error) => {
              if (wasNativeShareFailureHandled(error)) return
              const errorName = error && error.name
              if (errorName === 'AbortError' || errorName === 'NotAllowedError') {
                return
              }
              this.toast({
                message: (error && (error.msg || error.message)) || 'Unable to share. Please try again.',
                icon: 'cross'
              })
            })
          }
        } else {
          const lang = this.lang()
          this.showFailToast(lang.common_txt114 || 'Sharing is not supported on this browser')
        }
      } else if (i === 1) {
        if (!this.ensureInviteLink()) return
        openExternalUrl(`https://api.whatsapp.com/send?text=${encodeURIComponent(this.inviteCode || 'VUKAVI')}`)
      } else if (i === 2) {
        if (!this.ensureInviteLink()) return
        openExternalUrl(`https://t.me/share/url?url=${encodeURIComponent(this.inviteCode || '')}&text=VUKAVI`)
      } else if (i === 3) {
        return this.showUnsupportedShareTarget('Instagram')
      } else if (i === 4) {
        return this.showUnsupportedShareTarget('YouTube')
      } else if (i === 5) {
        if (!this.ensureInviteLink()) return
        openExternalUrl(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.inviteCode || '')}`)
      } else if (i === 6) {
        return this.showUnsupportedShareTarget('TikTok')
      } else if (i === 7) {
        if (!this.ensureInviteLink()) return
        openExternalUrl(`https://x.com/intent/tweet?text=VUKAVI&url=${encodeURIComponent(this.inviteCode || '')}`)
      }
    },
    async Init() {
      if (!this.token) {
        this.inviteCode = ''
        this.requireLogin()
        return
      }
      const previousInviteCode = this.inviteCode
      const inviteOrigin = getLocationOrigin()
      const inviteCountry = safeGetStorageItem(getLocalStorage(), 'country')
      try {
        const data = await Init()
        if (hasShareNeedLoginMarker(data)) {
          this.inviteCode = ''
          this.requireLogin()
        } else if ((isOkResponse(data) || hasShareSuccessMarker(data)) && !hasShareBlockingMarker(data)) {
          const content = contentOf(data)
          if (hasShareUnavailableMarker(content)) {
            if (!previousInviteCode || !hasShareReadUnavailableMarker(content)) {
              this.inviteCode = ''
            }
            this.showFailToast(this.inviteUnavailableMessage(content))
            return
          }
          const inviteCode = safeInviteCode(content.inviteCode)
          const inviteUrl = safeInviteUrl(
            inviteOrigin,
            inviteCountry,
            inviteCode
          )
          this.inviteCode = inviteUrl
          if (!inviteUrl) {
            const lang = this.lang()
            this.showFailToast(lang.common_txt114 || 'Invite link is unavailable')
          }
        } else if (hasShareUnavailableMarker(data)) {
          if (!previousInviteCode || !hasShareReadUnavailableMarker(data)) {
            this.inviteCode = ''
          }
          this.showFailToast(this.inviteUnavailableMessage(data))
        } else {
          this.inviteCode = ''
          this.showFailToast(this.inviteUnavailableMessage(data))
        }
      } catch (e) {
        if (!previousInviteCode || !hasShareReadUnavailableMarker(e)) {
          this.inviteCode = ''
        }
        this.showFailToast(this.inviteUnavailableMessage(e))
      }
    },
    copyText() {
      if (this.requiresShareLogin()) return
      const lang = this.lang()
      const copyValue = String(this.inviteCode || '').trim()
      if (!copyValue) {
        this.showToast({
          message: lang.noempt || lang.common_txt114 || 'No data available',
          icon: 'cross'
        })
        return
      }
      try {
        const copied = copyTextToClipboard(copyValue)
        this.showToast({
          message: copied === true ? lang.Sucesso : (lang.copy_failed || 'Copy failed'),
          icon: copied === true ? 'success' : 'cross'
        })
      } catch (e) {
        this.showToast({
          message: (e && (e.msg || e.message)) || lang.copy_failed || 'Copy failed',
          icon: 'cross'
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  padding: 0 5% 18%;
  // background: url(../../assets/img/common/sub_bg.png);
  // background-size: cover;
  // background-repeat: repeat;
}
.content-c2 {
  font-size: var(--vk-fs-md);
  font-weight: bold;
  margin-top: 15px;
  background-image: url('../../assets/img/bonus/cashback_rate_vip.png'); /* 指定背景图片的路径 */
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 260px; /* 或者指定具体的宽度 */
  padding: 5px 10px;
  font-weight: bold;
}
.content-c2s {
  font-size: var(--vk-fs-md);
  font-weight: bold;
  margin-top: 15px;
  background-image: url('../../assets/img/bonus/cashback_rate_vip.png'); /* 指定背景图片的路径 */
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 380px; /* 或者指定具体的宽度 */
  padding: 5px 10px;
  font-weight: bold;
}

.content-c3--qr {
  border-radius: 10px 10px 0 0;
}
.content-c3--qrt {
  color: #472600;
  background: linear-gradient(to bottom, #fae87d, #f7d975, #f4c56a, #f0ab5d);
  text-align: center;
  border-radius: 0 0 8px 8px;
  padding: 5px 0 3px;
  font-weight: bold;
  margin-top: -5px;
}
.content-c3--b {
  margin-top: 5px;
  display: flex;
  color: rgba(255, 255, 255, 0.65);
  background: rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding: 7px 10px;
  line-height: 23px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.content-c5 {
  margin-top: 10px;
  border-radius: 13px;
}
.content-c6 {
  padding: 0px 0px;
}
.content-c6--b {
  align-items: center;
  display: flex;
  background: #eef7f4;
  border-radius: 13px;
  padding: 10px 5px;
  width: 100%;
  margin-bottom: 10px;
}
.content-c7 {
  // border: 1px solid #686869;
  // border-radius: 13px;
  // padding: 20px 15px;
  // margin-top: 15px;
  line-height: 20px;
  color: @font-color;
  // font-size: var(--vk-fs-15);
}
.content-c3 {
  background-image: linear-gradient(180deg, #ffffff 0%, #ebf6ff 100%);
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.08);
  // border: 1px solid rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border-radius: 12px;
  padding: 10px 15px;
}
.content-c3--t2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  background: rgba(0, 0, 0, 0.04);
}
.content-c3--t2 p {
  width: 33%;
  text-align: center;
}
.content-c3 :last-child {
  border-radius: 0 0 12px 12px !important;
}

.content-c3--t {
  margin-top: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 12px 12px 0 0;
  padding: 3.2% 6% 3.2% 13%;
  background: rgba(0, 0, 0, 0.04);
}
.cont-share {
  border-radius: 12px;
  background-image: linear-gradient(99deg, #5093fe 0%, #91b9f8 85%);
  // box-shadow: inset 0px -2px 0px 0px rgba(0, 0, 0, 0.15);
  padding: 10px;
}
.content-c3-xx {
  background: #5093fe;
  border-radius: 8px;
  padding: 10px;
  margin: 7px 0 7px 0;
}
.fz-txt {
  background: #e3425c;
  padding: 5px 15px;
  border-radius: 5px;
  color: #ffffff !important;
}
</style>
